import userService from "../services/user.service";

// initial states
const expiresAtFromStorage = localStorage.getItem("loginExpiresAt");
const nameFromStorage = localStorage.getItem("name");

const state = {
  requestPending: false,
  status: {
    loggedIn: expiresAtFromStorage >= Date.now(),
    expiresAt: expiresAtFromStorage
  },
  name: nameFromStorage ? nameFromStorage : null
};

// getters
const getters = {
  isLoggedIn: state => state.status.loggedIn,
  isPending: state => state.requestPending,
  expiresAt: state => state.status.expiresAt,
  name: state => state.name
};

// actions
const actions = {
  login({ commit, state }, { username, password, token = "" }) {
    return new Promise(async (resolve, reject) => {
      if (typeof username === "undefined" || typeof password === "undefined") {
        reject("Internal Error: Username and password needed");
      } else if (state.loggedIn) {
        reject("You are already logged in");
      } else if (username.length < 4) {
        reject("Username must be longer than 3 characters");
      } else if (password.length !== 4) {
        reject("Password must be 4 characters long");
      } else {
        commit("startRequest");
        try {
          // make the request to the api
          const response = await userService.login(username, password, token);
          commit("login", {
            expirationDate: response.expiresAt,
            name: response.name
          });
          commit("endRequest");
          resolve();
        } catch (e) {
          commit("endRequest");
          reject(e);
        }
      }
    });
  },
  logout({ commit }, expired = false) {
    return new Promise(async (resolve, reject) => {
      commit("startRequest");
      try {
        await userService.logout(expired);
        commit("logout");
        commit("endRequest");
        resolve();
      } catch (e) {
        commit("endRequest");
        reject(e);
      }
    });
  },
  renew({ commit }) {
    return new Promise(async (resolve, reject) => {
      commit("startRequest");
      try {
        const newDate = await userService.renew();
        commit("endRequest");
        commit("loginRenew", newDate);
        resolve();
      } catch (e) {
        commit("endRequest");
        reject(e);
      }
    });
  }
};

// mutations
const mutations = {
  startRequest(state) {
    state.requestPending = true;
  },
  endRequest(state) {
    state.requestPending = false;
  },
  login(state, { expirationDate, name }) {
    state.status.loggedIn = true;
    state.status.expiresAt = expirationDate;
    state.name = name;
  },
  loginRenew(state, expirationDate) {
    state.status.expiresAt = expirationDate;
  },
  logout(state) {
    state.status.loggedIn = false;
    state.status.expiresAt = null;
    state.name = null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
